import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const _router = new Router({
  mode: "history",

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [
    {
      name: "home",
      path: "/",
      component: () => import("@/views/home.vue")
    },
    {
      name: "doc",
      path: "/doc",
      component: () => import("@/views/doc.vue"),
      children: [
        {
          name: "docSearch",
          path: "/doc-search",
          component: () => import("@/views/doc-search.vue")
        },
        {
          name: "docSearchInfo",
          path: "/doc-search-info/:id",
          component: () => import("@/views/doc-search-info.vue")
        },
        {
          name: "test",
          path: "/test",
          redirect: "/api-test/api-test",

          component: () => import("@/views/test.vue"),
          children: [
            {
              name: "api-test",
              path: "/api-test/:menuCode",
              component: () => import("@/views/api-test.vue")
            },
            {
              name: "error-code-test",
              path: "/error-code-test/:menuCode",
              component: () => import("@/views/error-code-test.vue")
            }
          ]
        },

        {
          name: "docApi",
          path: "/doc-api",
          component: () => import("@/views/doc-api.vue"),
          children: [
            {
              name: "docApiInfo",
              path: "/doc-api-info/:id",
              component: () => import("@/views/doc-api-info.vue")
            }
          ]
        },
        {
          name: "docTechnology",
          path: "/doc-technology",
          component: () => import("@/views/doc-technology.vue"),
          meta: {
            menuCode: "technical"
          },
          children: [
            {
              name: "docTechnologyInfo",
              path: "/doc-technology-info/:id/:menuCode",
              component: () => import("@/components/views/doc/doc-article.vue"),
              meta: {
                menuCode: "technical"
              }
            },
            {
              name: "docTechnologyList",
              path: "/doc-technology-list/:menuCode",
              component: () => import("@/components/views/doc/doc-list.vue"),
              meta: {
                menuCode: "technical"
              }
            }
          ]
        },
        {
          name: "docProduct",
          path: "/doc-product",
          component: () => import("@/views/doc-technology.vue"),
          meta: {
            menuCode: "product"
          },
          children: [
            {
              name: "docProductInfo",
              path: "/doc-product-info/:id/:menuCode",
              component: () => import("@/components/views/doc/doc-article.vue"),
              meta: {
                menuCode: "product"
              }
            },
            {
              name: "docProductList",
              path: "/doc-product-list/:menuCode",
              component: () => import("@/components/views/doc/doc-list.vue"),
              meta: {
                menuCode: "product"
              }
            }
          ]
        },
        {
          name: "docFaq",
          path: "/doc-faq",
          component: () => import("@/views/doc-faq.vue"),
          meta: {
            menuCode: "faq"
          },
          children: [
            {
              name: "docFaqInfo",
              path: "/doc-faq-info/:id/:menuCode",
              component: () => import("@/components/views/doc/doc-article.vue"),
              meta: {
                menuCode: "faq"
              }
            },
            {
              name: "docFaqList",
              path: "/doc-faq-list/:menuCode",
              component: () => import("@/components/views/doc/doc-list.vue"),
              meta: {
                menuCode: "faq"
              }
            }
          ]
        },
        {
          name: "docNotice",
          path: "/doc-notice",
          component: () => import("@/views/doc-faq.vue"),
          meta: {
            menuCode: "notice"
          },
          children: [
            {
              name: "docNoticeInfo",
              path: "/doc-notice-info/:id/:menuCode",
              component: () => import("@/components/views/doc/doc-article.vue"),
              meta: {
                menuCode: "notice"
              }
            },
            {
              name: "docNoticeList",
              path: "/doc-notice-list/:menuCode",
              component: () => import("@/components/views/doc/doc-list.vue"),
              meta: {
                menuCode: "notice"
              }
            }
          ]
        }
      ]
    }
  ]
});

_router.beforeEach((to, from, next) => {
  next();
});

export default _router;
